
import WebSocketClient from '@clients/web-socket.client';
import { IExternalCalendar } from '@app-types/websocket/externalCalender.types';

const socket = WebSocketClient.getInstance();


export function saveExternalCalendar(data: IExternalCalendar) {

  socket.sendJSON({
    newExternalCalendar: data,
  });
}

export function updateExternalCalendar(data: IExternalCalendar) {
  socket.sendJSON({
    updateExternalCalendar: data,
  });
}

export function deleteExternalCalendar(id: number) {
  socket.sendJSON({
    deleteExternalCalendar: id,
  });
}





// WEBPACK FOOTER //
// ./src/services/externalCalendar/externalCalendar.websocket.ts